import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LandingPage from './pages/LandingPage';
import ScrollToTop from './components/ScrollToTop';
import './styles/global.css';

// Non-critical pages: lazily loaded only when the user navigates to them.
// This keeps the initial bundle small and makes the landing page load faster.
const AboutPage       = lazy(() => import('./pages/AboutPage'));
const TermsPage       = lazy(() => import('./pages/TermsPage'));
const PrivacyPage     = lazy(() => import('./pages/PrivacyPage'));
const BlogPage        = lazy(() => import('./pages/BlogPage'));
const BlogDetailPage  = lazy(() => import('./pages/BlogDetailPage'));
const WorkPage        = lazy(() => import('./pages/WorkPage'));
const NotFoundPage    = lazy(() => import('./pages/NotFoundPage'));
const UnsubscribePage = lazy(() => import('./pages/UnsubscribePage'));

// Minimal inline fallback — keeps the black background consistent while JS loads.
const PageLoader = () => (
  <div style={{ minHeight: '100vh', background: '#0a0900' }} />
);

const RootLayout = () => (
  <>
    <ScrollToTop />
    <Suspense fallback={<PageLoader />}>
      <Outlet />
    </Suspense>
  </>
);

const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [
        { path: '/', element: <LandingPage /> },
        { path: '/about', element: <AboutPage /> },
        { path: '/blog', element: <BlogPage /> },
        { path: '/blog/category/:category', element: <BlogPage /> },
        { path: '/blog/:id', element: <BlogDetailPage /> },
        { path: '/work', element: <WorkPage /> },
        { path: '/terms', element: <TermsPage /> },
        { path: '/privacy', element: <PrivacyPage /> },
        { path: '/unsubscribe', element: <UnsubscribePage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#111000',
            color: '#fefce8',
            border: '1px solid rgba(245,200,0,0.15)',
            fontSize: '13px',
            fontFamily: 'DM Sans, sans-serif',
          },
          success: { iconTheme: { primary: '#f5c800', secondary: '#0a0900' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#0a0900' } },
        }}
      />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
